export default "__VITE_ASSET__qC_ySahm__"